import React, { useState } from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import "./index.css";
import { AtroposC } from "./components/AtroposC";
// import  Field  from "./components/Field";
import { FName } from "./components/FName";
import { Skills } from "./components/Skills";
import { Horizontal } from "./components/Horizontal";
import HorizontalScroll from "react-scroll-horizontal";
import Frontend_Projects from "./components/Frontend_Projects";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import ContactForm from "./components/ContactForm";
import Navbar from "./components/Navbar";

const anchors = ["Home", "Skills", "Projects", "Socials", "Email-me"];
const child = { width: `50vh`, height: `100vh` };
const parent = { width: `200vh`, height: `100vh` };


const App = () => {
  const [fullpageInstance, setFullpageInstance] = useState();
  return (
  // const [swiperInstance, setSwiperInstance] = useState();

  <div>
    <Navbar fullpageAPI={fullpageInstance}/>
    <ReactFullpage
      anchors={anchors}
      navigation
      navigationTooltips={anchors}
      navigat
      scrollHorizontally={true}
      sectionsColor={["#EE4E34", "#FCEDDA", "#FCEDDA", "#FCEDDA", "#FCEDDA"]}
      onLeave={(origin, destination, direction) => {
        console.log("onLeave event", { origin, destination, direction });
      }}
      render={({ state, fullpageApi }) => {
        setFullpageInstance(fullpageApi);
        console.log("render prop change", state, fullpageApi);

        return (
          <div>
            <div className="section" style={{position:"relative", zIndex: 999000}}>
              <FName fullpageApi={fullpageApi}/>
            </div>
            <div className="section">
              <Skills />
            </div>
            <div className="section">
              <Frontend_Projects/>
            </div>
            <div className="section">
              <AtroposC/>
            </div>
            <div className="section">
              <ContactForm />
            </div>
          </div>
        );
      }}
    />
    <div style={{ width: "200vw", overflow: "scroll", display: "flex" }}>
      <div style={{ background: "red", width: "100vw", height: "100vh" }}>
        <h1>Main Title</h1>
      </div>
      <div style={{ width: "100vw" }}>
        <AtroposC />
      </div>
    </div>
  </div>
)};
export default App;
